import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { apiUrl, BaseUrls } from '@app/app.constants';
import { SearchResult } from '@app/core/interfaces/search-result';
import { SearchType } from '@app/core/interfaces/search-type';
import { UserLevel } from '@app/core/models/user-level';
import { Utils } from '@app/shared/services/utils.service';
import { wrapError } from '@app/utils/rxjs';
import { Observable } from 'rxjs';
import { mergeMap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class SearchRepository {
  constructor(
    private http: HttpClient,
    private utils: Utils
  ) {}

  searchEnterprise(query: string, types?: SearchType[]): Observable<SearchResult> {
    const urls = {
      [UserLevel.ServiceProviderAdmin]: BaseUrls.ServiceProvider.Enterprise + '/search',
      [UserLevel.EnterpriseAdmin]: BaseUrls.Enterprise.Enterprise + '/search',
    };

    return this.utils.apiUrl(urls).pipe(
      mergeMap((url) =>
        this.http.get<SearchResult>(url, {
          params: this.getQueryParams(query, types),
        })
      ),
      wrapError('search-repository:search-enterprise')
    );
  }

  searchReseller(query: string, resellerId: number | string, types?: SearchType[]): Observable<SearchResult> {
    const url = apiUrl(BaseUrls.ServiceProvider.ServiceProvider + `/${resellerId}/search`);

    return this.http
      .get<SearchResult>(url, {
        params: this.getQueryParams(query, types),
      })
      .pipe(wrapError('search-repository:search-reseller'));
  }

  private getQueryParams(query: string, types: SearchType[]): HttpParams {
    let params = new HttpParams({
      fromObject: {
        query,
      },
    });

    if (types != null) {
      params = params.append('types', types.join(','));
    }
    return params;
  }
}
